import { useState, useEffect } from "react";
import axios from "axios";
import { Gauge } from "lucide-react";
import { API } from "../../context/AuthContext";

export default function CoverageBar({ caseId }) {
  const [cov, setCov] = useState(null);

  useEffect(() => {
    setCov(null);
    axios.get(`${API}/registry-coverage`, { params: { case_id: caseId } })
      .then((res) => setCov(res.data))
      .catch(() => {});
  }, [caseId]);

  if (!cov) return null;
  const color = cov.pct >= 70 ? "#34d399" : cov.pct >= 35 ? "#f59e0b" : "#fb7185";

  return (
    <div className="max-w-6xl mx-auto w-full px-6 pt-4" data-testid="coverage-bar">
      <div className="bg-[#131f3a] border border-white/5 rounded-2xl px-5 py-3 flex flex-col sm:flex-row sm:items-center gap-3">
        <div className="flex items-center gap-2 shrink-0">
          <Gauge className="w-4 h-4" style={{ color }} />
          <span className="text-[10px] font-mono font-bold uppercase tracking-wide text-gray-300">Registry Coverage</span>
        </div>
        <div className="flex-1 h-2 bg-gray-950 rounded-full overflow-hidden border border-white/5">
          <div className="h-full rounded-full transition-all duration-700" style={{ width: `${cov.pct}%`, backgroundColor: color }} data-testid="coverage-progress" />
        </div>
        <div className="text-[10px] font-mono text-gray-400 shrink-0 flex items-center gap-2 flex-wrap">
          <span className="font-bold" style={{ color }} data-testid="coverage-pct">{cov.pct}% of required data captured</span>
          <span className="text-gray-600">·</span>
          <span data-testid="coverage-docs">{cov.docs_missing} document{cov.docs_missing === 1 ? "" : "s"} to go</span>
          <span className="text-gray-600">·</span>
          <span>{cov.total_filled} fields on file</span>
        </div>
      </div>
    </div>
  );
}
